export default __webpack_public_path__ + "static/media/p3-10.368259b7.png";